import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormLegendComponent } from './form-legend.component';

@NgModule({
  declarations: [FormLegendComponent],
  imports: [CommonModule],
  exports: [FormLegendComponent]
})
export class FormLegendModule {}
